import { ThemeOptions } from "@mui/material/styles";

import { typographyOverrides } from "./typography";
import { buttonOverrides } from "./button";
import { menuOverrides } from "./menu";
import { menuItemOverrides } from "./menuItem";
import { chipOverrides } from "./chip";
import { radioOverrides } from "./radio";
import { formControlOverrides } from "./formControl";
import { inputLabelOverrides } from "./inputLabel";
import { filledInputOverrides } from "./filledInput";
import { outlinedInputOverrides } from "./outlinedInput";
import { inputOverrides } from "./input";
import { formHelperTextOverrides } from "./formHelperText";

import { cardOverrides } from "./card";
import { linearProgressOverrides } from "./linearProgress";

export const componentOverrides: ThemeOptions = {
	components: {
		...cardOverrides,
		...linearProgressOverrides,

		// * THE COMPONENTS BELOW ARE PLAYBOOK APPROVED
		...typographyOverrides,
		...buttonOverrides,
		...menuOverrides,
		...menuItemOverrides,
		...chipOverrides,
		...radioOverrides,

		/* 
		MuiTextField is an abstraction of these components:
		- FormControl
		- InputLabel
		- FilledInput
		- OutlinedInput
		- Input
		- FormHelperText
		
		It's preferable to customize it by customizing the components above.
		*/
		...formControlOverrides,
		...inputLabelOverrides,
		...filledInputOverrides,
		...outlinedInputOverrides,
		...inputOverrides,
		...formHelperTextOverrides,
	},
};
